import {getDashboardPeriods} from 'services/utils/misc'
import {styled} from '@mui/material'
import {Texts} from 'appearance'
import {useState} from 'react'
import {useGetPlannerActivitiesQuery, useI18n} from 'store/Store'
import SubscriptionItem from './SubscriptionItem'
import PickSubscription from './PickSubscription'
import Button from 'components/Control/Button'

const Subscriptions = ({isMobile}) => {
    const {i18n} = useI18n()
    const [pickSubscription, setPickSubscription] = useState(false)
    const {today, monthAgo} = getDashboardPeriods()
    const {data: activities} = useGetPlannerActivitiesQuery({
        activitiesFrom: monthAgo,
        activitiesTo: today,
    })
    const {subscription, status} = activities || {}

    console.log('payment - activities', activities)

    const handlePickSubscription = () => {
        setPickSubscription(true)
    }

    if (!activities) {
        return null
    }

    return (
        <Container isMobile={isMobile}>
            {pickSubscription ? (
                <PickSubscription currentSubscription="x" />
            ) : (
                <>
                    <Header>
                        <Title flexItem>
                            {i18n.t('settings.subscriptionName', {
                                name: subscription?.PlannerSubscriptionName,
                            })}
                        </Title>
                    </Header>

                    <div>
                        <SubscriptionItem
                            title={i18n.t('settings.subscription')}
                            value={subscription.PlannerSubscriptionPrice}
                            valueSuffix="₪"
                        />
                    </div>

                    <Row>
                        <SubscriptionItem
                            title={i18n.t('settings.freeReports')}
                            value={subscription.FreeReports}
                        />
                    </Row>

                    <Row>
                        <SubscriptionItem
                            title={i18n.t('settings.issuedReports')}
                            //TODO: get from Raz
                            value={'-'}
                        />
                        <SubscriptionItem
                            title={i18n.t('settings.reportPrice')}
                            value={subscription.PriceReports}
                            valueSuffix="₪"
                        />
                        <SubscriptionItem
                            title={i18n.t('settings.totalReports')}
                            value={status.paymentReports}
                            valueSuffix="₪"
                        />
                    </Row>
                    <Row>
                        <SubscriptionItem
                            title={i18n.t('settings.totalSubscriptionPrice')}
                            value={status.paymentTotal}
                            valueSuffix="₪"
                            boldValue
                        />

                        <Button
                            disabled={true}
                            onClick={handlePickSubscription}>
                            {i18n.t('settings.changeSubscription')}
                        </Button>
                    </Row>
                </>
            )}
        </Container>
    )
}

export default Subscriptions

const Container = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 24px;
    background: #cbddee33;
    width: 100%;
    height: ${({isMobile}) => (isMobile ? 'auto' : '100%')};
    padding: 24px;
`

const Header = styled('div')`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`

const Title = styled(Texts.BoldText)`
    flex: 2;
`

const Row = styled('div')`
    display: flex;
    justify-content: space-between;
`
